<template>
  <span class="flex items-center gap-2">
    <span class="flex w-full items-center gap-2">
      <span class="flex items-center">
        <span>
          {{ selectedOption.label }}
        </span>

        <BadgeLabel
          v-if="
            selectedOption.isDefault ||
            selectedOption.value === sizeStore.mostChosenSku
          "
          :label="$t('pages.configurator.sizes.most_chosen')"
          class="ml-3 hidden shrink-0 bg-order-buttons/20 text-order-buttons md:flex"
        />
      </span>

      <FilterPredefinedShowText
        v-if="
          !selectedOption.isDefault &&
          selectedOption.predefinedShowText &&
          showPredefinedShowText
        "
        :predefined-show-text="selectedOption.predefinedShowText"
      />
    </span>

    <span v-if="showPrices" class="flex justify-end">
      <FilterPrices :option="selectedOption" />
    </span>
  </span>

  <span
    v-if="loading"
    class="absolute inset-y-0 right-0 flex items-center pr-2"
  >
    <SpinnerIcon />
  </span>

  <span
    v-else
    class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2"
  >
    <FontAwesomeIcon
      :icon="{ prefix: 'fas', iconName: 'chevron-down' }"
      :class="
        open ? ['rotate-180', 'duration-200'] : ['rotate-0', 'duration-200']
      "
      class="text-gray-600"
      aria-hidden="true"
    />
  </span>
</template>

<script setup lang="ts">
import { computed, type ComputedRef, type PropType } from 'vue';
import type { SelectorOption } from '@/types/Configurator/SelectorOption';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import SpinnerIcon from '@/components/Icons/SpinnerIcon.vue';
import BadgeLabel from '@/components/BadgeLabel.vue';
import FilterPrices from '@/pages/ProductPage/partials/ProductFilters/FilterPrices.vue';
import FilterPredefinedShowText from '@/pages/ProductPage/partials/ProductFilters/FilterPredefinedShowText.vue';
import { useFilterStore } from '@/stores/Configurator/FilterStore.ts';
import { useSizeStore } from '@/stores/Configurator/SizeStore.ts';

const props = defineProps({
  selectedOption: {
    type: Object as PropType<SelectorOption>,
    required: true,
  },

  open: {
    type: Boolean,
    required: false,
    default: false,
  },

  loading: {
    type: Boolean,
    required: false,
    default: false,
  },

  showPrices: {
    type: Boolean,
    required: false,
    default: true,
  },

  index: {
    type: [String, Number] as PropType<string | number>,
    required: false,
    default: undefined,
  },

  isShowingPredefinedShowText: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const sizeStore = useSizeStore();
const filterStore = useFilterStore();

const showPredefinedShowText: ComputedRef<boolean> = computed(
  () =>
    props.isShowingPredefinedShowText &&
    filterStore.defaultFilterSkus[props.index ?? 0] ===
      props.selectedOption?.value
);
</script>
